// src/features/landing/presentation/components/Navbar.jsx
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../../features/auth/application/AuthContext";
import "../../../../features/auth/presentation/styles/auth.css";

const PREMIUM_ITEMS = [
    { label: "채용목록", to: "/jobs",            roles: null },
    { label: "인재등록", to: "/premium/apply",   roles: ['JOB_SEEKER'] },
    { label: "채용등록", to: "/premium/company", roles: ['COMPANY'] },
];

function getVisibleItems(isLoggedIn, role) {
    return PREMIUM_ITEMS.filter(({ roles }) => {
        if (!roles) return true;
        if (!isLoggedIn) return true;
        return roles.includes(role);
    });
}

export function Navbar({ visible = true }) {
    const { isLoggedIn, member } = useAuthContext();
    const navigate = useNavigate();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [premiumOpen, setPremiumOpen] = useState(false);

    const visiblePremiumItems = getVisibleItems(isLoggedIn, member?.role);

    const toggleMobileMenu = () => setMobileMenuOpen((v) => !v);
    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
        setPremiumOpen(false);
    };

    return (
        <>
            <header
                className={`navbar ${
                    visible ? "navbar--visible" : "navbar--hidden"
                }`}
            >
                <div className="navbar-inner">
                    <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
                        <img src="/images/logo/main_logo.png" alt="RISING BROKERS Logo" className="navbar-logo-image" />
                        <div className="navbar-logo-text">
                            <span className="navbar-logo-main">RISING</span>
                            <span className="navbar-logo-sub">BROKERS</span>
                        </div>
                    </Link>

                    {/* Desktop Menu */}
                    <nav className="navbar-menu">
                        <Link to="/landing">홈</Link>
                        <Link to="/about">회사소개</Link>
                        <Link to="/service">서비스</Link>
                        <Link to="/careers">입사지원</Link>
                        <Link to="/premium/job-board">설계사 채용관</Link>

                        {/* 프리미엄 채용관 드롭다운 */}
                        <div className="navbar-dropdown-wrapper">
                            <Link to="/premium" className="navbar-dropdown-trigger">
                                프리미엄 채용관
                            </Link>
                            <div className="navbar-dropdown">
                                <div className="navbar-dropdown-inner">
                                    {visiblePremiumItems.map((item) => (
                                        <Link
                                            key={item.to}
                                            to={item.to}
                                            className="navbar-dropdown-item"
                                        >
                                            {item.label}
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <Link to="/rb-bridge">RB Bridge</Link>
                        <Link to="/contact">제휴문의</Link>
                    </nav>

                    {/* Auth / User Menu */}
                    {isLoggedIn ? (
                        <div className="navbar-user">
                            <button
                                className="navbar-user__trigger"
                                onClick={() => navigate('/account')}
                            >
                                {member?.email?.split('@')[0]} ▾
                            </button>
                        </div>
                    ) : (
                        <div className="navbar-auth">
                            <Link to="/login" className="navbar-auth__login">로그인</Link>
                            <Link to="/register" className="navbar-auth__register">회원가입</Link>
                        </div>
                    )}

                    {/* CTA Button */}
                    <span className="navbar-cta-divider" />
                    <a href="http://pf.kakao.com/_Tdzxen" target="_blank" rel="noopener noreferrer" className="navbar-cta-button">상담하기</a>

                    {/* Mobile Hamburger Button */}
                    <button
                        className="hamburger-button"
                        onClick={toggleMobileMenu}
                        aria-label="메뉴 열기"
                    >
                        <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
                        <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
                        <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
                    </button>
                </div>
            </header>

            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <>
                    <div
                        className="mobile-menu-overlay"
                        onClick={closeMobileMenu}
                    ></div>
                    <nav className="mobile-menu">
                        <Link to="/landing" className="mobile-menu-item" onClick={closeMobileMenu}>
                            홈
                        </Link>
                        <Link to="/about" className="mobile-menu-item" onClick={closeMobileMenu}>
                            회사소개
                        </Link>
                        <Link to="/service" className="mobile-menu-item" onClick={closeMobileMenu}>
                            서비스
                        </Link>
                        <Link to="/careers" className="mobile-menu-item" onClick={closeMobileMenu}>
                            입사지원
                        </Link>
                        <Link to="/premium/job-board" className="mobile-menu-item" onClick={closeMobileMenu}>
                            설계사 채용관
                        </Link>

                        {/* 모바일 프리미엄 채용관 아코디언 */}
                        <button
                            className="mobile-menu-item mobile-menu-accordion-trigger"
                            onClick={() => setPremiumOpen((v) => !v)}
                        >
                            프리미엄 채용관
                            <span className={`mobile-accordion-arrow ${premiumOpen ? 'open' : ''}`}>▾</span>
                        </button>
                        {premiumOpen && (
                            <div className="mobile-accordion-sub">
                                {visiblePremiumItems.map((item) => (
                                    <Link
                                        key={item.to}
                                        to={item.to}
                                        className="mobile-menu-item mobile-menu-sub-item"
                                        onClick={closeMobileMenu}
                                    >
                                        {item.label}
                                    </Link>
                                ))}
                            </div>
                        )}

                        <Link to="/rb-bridge" className="mobile-menu-item" onClick={closeMobileMenu}>
                            RB Bridge
                        </Link>
                        <Link to="/contact" className="mobile-menu-item" onClick={closeMobileMenu}>
                            제휴문의
                        </Link>
                        <a href="http://pf.kakao.com/_Tdzxen" target="_blank" rel="noopener noreferrer" className="mobile-menu-item mobile-menu-cta" onClick={closeMobileMenu}>
                            바로 상담하기
                        </a>

                        <div style={{ borderTop: '1px solid #e9ecef', margin: '8px 0' }} />
                        {isLoggedIn ? (
                            <button
                                className="mobile-menu-item"
                                style={{ background: 'none', border: 'none', width: '100%', cursor: 'pointer', fontSize: '1rem', fontWeight: 600 }}
                                onClick={() => { navigate('/account'); closeMobileMenu(); }}
                            >
                                내 계정
                            </button>
                        ) : (
                            <>
                                <Link to="/login" className="mobile-menu-item" onClick={closeMobileMenu}>로그인</Link>
                                <Link to="/register" className="mobile-menu-item" style={{ color: '#f16102', fontWeight: 700 }} onClick={closeMobileMenu}>회원가입</Link>
                            </>
                        )}
                    </nav>
                </>
            )}

            <style jsx>{`
                .navbar-cta-button {
                    order: 4;
                    display: inline-flex;
                    align-items: center;
                    padding: 8px 18px;
                    border-radius: 8px;
                    background: #f16102;
                    color: #fff !important;
                    font-weight: 700;
                    font-size: 14px;
                    text-decoration: none;
                    white-space: nowrap;
                    flex-shrink: 0;
                    transition: background 0.2s ease;
                }

                .navbar-cta-button:hover {
                    background: #d95502;
                }

                .navbar-cta-divider {
                    order: 4;
                    width: 1px;
                    height: 18px;
                    background: #e0e0e0;
                    flex-shrink: 0;
                }

                .hamburger-button {
                    display: none;
                    flex-direction: column;
                    justify-content: space-around;
                    width: 30px;
                    height: 25px;
                    background: transparent;
                    border: none;
                    cursor: pointer;
                    padding: 0;
                    z-index: 1001;
                }

                .hamburger-line {
                    width: 30px;
                    height: 3px;
                    background: #2c3e50;
                    border-radius: 2px;
                    transition: all 0.3s ease;
                    transform-origin: center;
                }

                .hamburger-line.open:nth-child(1) {
                    transform: translateY(11px) rotate(45deg);
                }

                .hamburger-line.open:nth-child(2) {
                    opacity: 0;
                }

                .hamburger-line.open:nth-child(3) {
                    transform: translateY(-11px) rotate(-45deg);
                }

                .mobile-menu-overlay {
                    display: none;
                    position: fixed;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    z-index: 999;
                    animation: fadeIn 0.3s ease;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                .mobile-menu {
                    display: none;
                    position: fixed;
                    top: 0;
                    right: 0;
                    width: 280px;
                    height: 100vh;
                    background: white;
                    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
                    z-index: 1000;
                    padding: 100px 30px 30px;
                    /* 메뉴 항목이 화면보다 길면(예: 375×667) 아래 로그인·회원가입까지 스크롤로 닿게 */
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    animation: slideIn 0.3s ease;
                }

                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                    }
                    to {
                        transform: translateX(0);
                    }
                }

                .mobile-menu-item {
                    display: block;
                    padding: 18px 20px;
                    color: #2c3e50;
                    text-decoration: none;
                    font-size: 1.1rem;
                    font-weight: 600;
                    border-bottom: 1px solid #e9ecef;
                    transition: all 0.3s ease;
                    text-align: center;
                }

                .mobile-menu-item:hover {
                    background: #f8f9fa;
                    color: #ff5722;
                }

                .mobile-menu-item:first-child {
                    border-top: 1px solid #e9ecef;
                }

                .mobile-menu-cta {
                    background: transparent;
                    color: #ff5722 !important;
                    border-radius: 8px;
                    text-align: center;
                    font-weight: 700;
                }

                .mobile-menu-cta:hover {
                    background: #fff5f2;
                    color: #e64a19 !important;
                    padding-left: 20px;
                }

                .mobile-menu-accordion-trigger {
                    width: 100%;
                    text-align: center;
                    background: none;
                    border: none;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 8px;
                }

                .mobile-accordion-arrow {
                    font-size: 14px;
                    color: #aaa;
                    transition: transform 0.2s ease;
                    display: inline-block;
                }

                .mobile-accordion-arrow.open {
                    transform: rotate(180deg);
                }

                .mobile-accordion-sub {
                    background: #faf8f6;
                }

                .mobile-menu-sub-item {
                    font-size: 1rem !important;
                    font-weight: 500 !important;
                    color: #555 !important;
                }

                .mobile-menu-sub-item:hover {
                    color: #f16102 !important;
                    background: #fff3ed;
                }

                /* 데스크톱 메뉴 8개가 한 줄에 들어가지 않는 폭(1200px 미만)부터 햄버거 메뉴로 전환 */
                @media (max-width: 1199px) {
                    .navbar-menu {
                        display: none;
                    }

                    .navbar-cta-button {
                        display: none;
                    }

                    .navbar-cta-divider {
                        display: none;
                    }

                    .navbar-auth {
                        display: none;
                    }

                    .navbar-user {
                        display: none;
                    }

                    .hamburger-button {
                        display: flex;
                    }

                    .mobile-menu-overlay {
                        display: block;
                    }

                    .mobile-menu {
                        display: flex;
                        flex-direction: column;
                    }
                }
            `}</style>
        </>
    );
}
